;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import get from "lodash/get"
import Image from "next/image"

/**
 * Avatar trigger button. Extra props (onClick, aria-*, ref from a Radix
 * DropdownMenuTrigger `asChild`) are spread onto the underlying button.
 */
export default function PersonalAvatar({
  firstName,
  lastName,
  photoUrl,
  ...rest
}: React.ComponentProps<"button"> & {
  firstName?: string | null
  lastName?: string | null
  photoUrl?: string | null
}) {
  // get either the initials or the photo url
  const renderPhoto = () => {
    return (
      <Image
        src={photoUrl as string}
        alt={`${getFullName()} picture`}
        width={40}
        height={40}
        style={{
          objectFit: "cover",
          overflow: "hidden",
          width: "auto",
          height: "auto",
        }}
        priority={true}
      />
    )
  }
  const renderInitials = () => {
    return `${get(firstName, "[0]", "")}${get(lastName, "[0]", "")}`
  }

  const getFullName = () => {
    return `${firstName ?? ""} ${lastName ?? ""}`.trim() || "User"
  }

  return (
    <button
      type="button"
      aria-label={`${getFullName()} account menu`}
      {...rest}
      className="ml-[6px] inline-flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full border border-solid border-[#D9D9D9] bg-white p-0 drop-shadow-[0px_1px_1px_rgba(0,0,0,0.25)] hover:bg-white hover:shadow-[0px_4px_4px_rgba(0,0,0,0.25)]"
    >
      <span className="relative flex h-[34px] w-[34px] items-center justify-center overflow-hidden rounded-full bg-[#092C3C] font-bebas text-[20px] leading-[150%] font-normal tracking-[0.09em] text-[#00B2FF] select-none">
        {photoUrl ? renderPhoto() : renderInitials()}
      </span>
    </button>
  )
}
